import { apiGet, apiPost } from '../services/apiClient';

export const getPackagesLandingPage = () => apiGet('/api/packages/landing-page');
export const getPackagesListingConfig = () => apiGet('/api/packages-listing');
export const getPackagesFilters = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      if (value.length) qs.set(key, value.join(','));
      return;
    }
    qs.set(key, value);
  });
  return apiGet(`/api/packages/filters${qs.toString() ? `?${qs}` : ''}`);
};

export const searchPackages = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      if (value.length) qs.set(key, value.join(','));
      return;
    }
    qs.set(key, value);
  });
  return apiGet(`/api/packages${qs.toString() ? `?${qs}` : ''}`);
};

export const getPackageBySlug = (slug) => apiGet(`/api/packages/${slug}`);
export const getRelatedPackages = (slug, limit = 4) =>
  apiGet(`/api/packages/related/${slug}${limit ? `?limit=${limit}` : ''}`);

export const submitPackageEnquiry = (payload) => apiPost('/api/packages/enquiries', payload);
